import React from 'react';

import RadioButton from '../../Shared/RadioButton/RadioButton';
import { collegeDistributeReasons } from '../../../settings/settings';

import './CollegeDistributeDistributionReason.scss';

const CollegeDistributeDistributionReason = (props) => {
  const { agreementID, distributionReason, updateDistributionReason } = props;
  return (
    <div className="college-distribute-distribution-reason-container">
      Distribution Reason (Optional)
      {collegeDistributeReasons.map((reason) => (
        <div
          key={reason.value}
          className="college-distribute-distribution-reason"
        >
          <RadioButton
            checked={reason.value === distributionReason}
            displayErrorMessage
            labelText={reason.label}
            name="distributionReason"
            onChange={() =>
              updateDistributionReason({
                agreementID,
                distributionReason: reason.value,
              })
            }
            tabIndex="5"
          />
        </div>
      ))}
    </div>
  );
};

export default CollegeDistributeDistributionReason;
